import type { ReminderScheduleNotificationV2Payload } from '@/types/apps/reminder-schedule-notification-v2.type';
import type { ApiResponse } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export class ReminderScheduleNotificationV2Service implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        markAsRead: () =>
            '/api/v2/reminder-schedule-notification/mark-all-as-read',
    };

    public markAsRead(
        payload: ReminderScheduleNotificationV2Payload
    ): Promise<ApiResponse<{}>> {
        return this.apiClient.postApi(this.endpoints.markAsRead(), payload);
    }
}
